/*
  Sleep Suisse reviews: loading and rendering.

  The reviews themselves live in assets/ss-reviews-data.js (window.SS_REVIEWS), generated from the
  client's review export. That file is only downloaded on pages that show reviews. The score, the
  count, the star bars and the filter counts are all calculated from it, so replacing that one file
  keeps every number on the site in step.
*/
window.SSReviews = (function () {
  var waiting = null;

  function load(src, cb) {
    if (window.SS_REVIEWS) { cb(window.SS_REVIEWS); return; }
    if (waiting) { waiting.push(cb); return; }
    waiting = [cb];
    var s = document.createElement('script');
    s.src = src; s.async = true;
    s.onload = function () { var q = waiting; waiting = null; q.forEach(function (f) { f(window.SS_REVIEWS || []); }); };
    document.head.appendChild(s);
  }

  function fmt(n) { return Number(n).toLocaleString('en-US'); }

  function esc(t) {
    return String(t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function stats(all) {
    var dist = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 }, sum = 0;
    all.forEach(function (r) { dist[r.r] = (dist[r.r] || 0) + 1; sum += r.r; });
    return { count: all.length, dist: dist, score: all.length ? (Math.round((sum / all.length) * 10) / 10).toFixed(1) : '0.0' };
  }

  function card(r) {
    var star = '<svg><use href="#i-star"/></svg>';
    var initials = r.n.split(' ').map(function (p) { return p.charAt(0); }).join('').slice(0, 2);
    return '' +
      '<article class="rcard">' +
        '<div class="rcard__top">' +
          '<span class="stars" aria-label="' + r.r + ' out of 5">' + new Array(r.r + 1).join(star) + '</span>' +
          (r.v ? '<span class="rcard__v">Verified purchase</span>' : '') +
        '</div>' +
        '<h4>' + esc(r.t) + '</h4>' +
        '<p>' + esc(r.b) + '</p>' +
        '<div class="rcard__who">' +
          '<span class="rcard__av">' + esc(initials) + '</span>' +
          '<span>' + esc(r.n) + '</span><span class="rcard__d">' + esc(r.d) + '</span>' +
        '</div>' +
      '</article>';
  }

  /* 5 to 1 star distribution. A star level with a handful of reviews shows "<1%", never a misleading 0%. */
  function bars(mount, st) {
    mount.innerHTML = [5, 4, 3, 2, 1].map(function (n) {
      var c = st.dist[n] || 0;
      var exact = st.count ? (c / st.count) * 100 : 0;
      var label = c && exact < 1 ? '<1%' : Math.round(exact) + '%';
      var width = c ? Math.max(exact, 1) : 0;
      return '' +
        '<div class="rbar">' +
          '<span>' + n + ' star</span>' +
          '<span class="rbar__track"><span class="rbar__fill" style="width:' + width.toFixed(2) + '%"></span></span>' +
          '<span class="rbar__pc">' + label + '</span>' +
        '</div>';
    }).join('');
  }

  /* Wires an aria-pressed button group. Calls back with the chosen data value. */
  function group(root, attr, onPick) {
    if (!root) return;
    var btns = root.querySelectorAll('button');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
        onPick(b.dataset[attr]);
      });
    });
  }

  return { load: load, fmt: fmt, stats: stats, card: card, bars: bars, group: group };
})();
